// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__ZvRe0","slider":"Switch_slider__wbE51"};